import { EducationType } from "components/about/education-and-experience/types"

export const Education: EducationType[] = [
  {
    id: 1,
    degree: "Bachelor In Information Technology",
    schoolCollegeName: "Silver Oak University (GTU Affiliated)",
    year: "2017-2021",
    text: "Score of CGPA 7.90",
  },
  {
    id: 2,
    degree: "GHSEB Board",
    schoolCollegeName: "Gyanda Girls' High School",
    year: "2017",
    text: "Percentage of 74.85% in 12th board",
  },
  {
    id: 3,
    degree: "GSEB Board",
    schoolCollegeName: "Gyanda Girls' High School",
    year: "2015",
    text: "Percentage of 89.66% in 10th board",
  },
]

export const Experience: EducationType[] = [
  {
    id: 1,
    degree: "Wordpress Developer",
    schoolCollegeName: "Frontend Army Infocon Pvt. Ltd.",
    year: "May 2021- Jan 2022",
    text: "I worked in this company for 9 months as a WordPress Developer.",
  },
  {
    id: 2,
    degree: "React Developer",
    schoolCollegeName: "Intelli Techwork LLP",
    year: "Feb 2022 - Jan 2024",
    text: "I worked in this company for 2 years as a React Developer.",
  },

  {
    id: 3,
    degree: "Software Developer (Freelance)",
    schoolCollegeName: "Galamela India Private Limited",
    year: "May 2024 - Jun 2024",
    text: "I worked in this company for 2 months as a freelancer frontend Software Developer.",
  },
]
